import messages from '@/shared/i18n/en/billing-upgrade';
import { tr } from '@/shared/i18n/translate';
import { fmtNumber } from '@/shared/lib/format-locale';

const UNIT_KEYS = ['unitKB', 'unitMB', 'unitGB', 'unitTB', 'unitPB'] as const;

function fixed(n: number, digits: number): string {
  return fmtNumber(n, { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

/**
 * "512 KB", "1.5 GB" in the UI language ("1,5 ГБ").
 * `coarse` (billing copy): whole KB/MB, one decimal for GB.
 * `fine` (storage meter): one decimal under 10, whole above, up to PB.
 */
export function formatBytes(n: number, mode: 'coarse' | 'fine' = 'coarse'): string {
  if (n < 1024) return tr(messages, 'unitB', { n: fmtNumber(n) });
  if (mode === 'coarse') {
    if (n < 1024 * 1024) return tr(messages, 'unitKB', { n: fixed(n / 1024, 0) });
    if (n < 1024 * 1024 * 1024) return tr(messages, 'unitMB', { n: fixed(n / 1024 / 1024, 0) });
    return tr(messages, 'unitGB', { n: fixed(n / 1024 / 1024 / 1024, 1) });
  }
  let val = n / 1024;
  for (const key of UNIT_KEYS.slice(0, 4)) {
    if (val < 1024) return tr(messages, key, { n: fixed(val, val < 10 ? 1 : 0) });
    val /= 1024;
  }
  return tr(messages, 'unitPB', { n: fixed(val, 1) });
}
